// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__9mBB2iBvbfW9nzwY5_l53","spacer":"style_spacer__p5UXudQA4nAD6ZA_gTC_p"};